import React, { useState } from 'react';
import {Box, Tabs, Tab, Typography, styled, Stack} from '@mui/material';
import {useTheme} from "@mui/material/styles";

function TabPanel({ children, value, index }) {
  return (
    <div role="tabpanel" hidden={value !== index}>
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

const ExampleText = styled(Typography)(({ theme }) => ({
  color: theme.palette.base.rothko4,
  fontSize: 'small',
  marginBottom: '8px',
}));

const ExampleTabs = ({ example }) => {
  const [tabIndex, setTabIndex] = useState(0);
  const handleChange = (e, newIndex) => setTabIndex(newIndex);
  const theme = useTheme()

  return (
    <Box>
      {example.description && (
        <ExampleText dangerouslySetInnerHTML={{ __html: example.description }} />
      )}

      {/* Light‐gray container */}
      <Box sx={{ bgcolor: theme.palette.base.rothko5, p: 1, borderRadius: 2 }}>
        {/* Tabs with a little bottom margin */}
        <Tabs
          value={tabIndex}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            minHeight: 0,
            marginBottom: 1
        }}
          TabIndicatorProps={{ style: { display: 'none' } }}
        >
          {example.code.map((c, i) => (
            <Tab
              key={i}
              label={c.form}
              sx={{
                textTransform: 'none',
                p: '8px 16px',
                minHeight: 0,
                minWidth: 0,
                '&.Mui-selected': {
                  bgcolor: 'primary.main',
                  color: 'primary.contrastText',
                  borderRadius: 2,
                },
              }}
            />
          ))}
        </Tabs>

        {/* Panel contents */}
        {example.code.map((c, i) => (
          <TabPanel key={i} value={tabIndex} index={i}>
            <Box
              component="pre"
              sx={{
                fontFamily: 'Monospace',
                bgcolor: 'grey.900',
                color: 'grey.200',
                p: 2,
                borderRadius: 1,
                overflowX: 'auto',
                margin: 0
              }}
            >
              {c.code}
            </Box>
          </TabPanel>
        ))}
      </Box>
    </Box>
  );
};


const ApiExamplesView = ({ examples }) => (
  <Stack spacing={2}>
    {examples.map((ex, idx) => (
      <ExampleTabs key={idx} example={ex} />
    ))}
  </Stack>
);

export default ApiExamplesView;